import { useEffect, useRef } from "react";

export function usePopoverClickOutside<
  TTrigger extends HTMLElement = HTMLButtonElement,
  TDropdown extends HTMLElement = HTMLDivElement,
>(opened: boolean, onClose: () => void) {
  const triggerRef = useRef<TTrigger>(null);
  const dropdownRef = useRef<TDropdown>(null);

  useEffect(() => {
    if (!opened) return;
    const handler = (e: MouseEvent | TouchEvent) => {
      const target = e.target as Node;
      if (
        triggerRef.current?.contains(target) ||
        dropdownRef.current?.contains(target)
      ) return;
      onClose();
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [opened, onClose]);

  return { triggerRef, dropdownRef };
}
